import React from 'react'
import {NumericFormat} from 'react-number-format'

const InputMoneda = ({
  onValueChange,
  estilosContenedor,
  estilosInput,
  placeholder,
  titulo,
  deshabilitado,
  valor,
  formatoVacio,
  onFocus,
  prefix = '$',
  deshabilitarTab = false,
  isAllowed = (values) => {
    return true
  },
}) => {
  return (
    <div
      className={`${estilosContenedor} flex justify-start items-center flex-wrap`}
    >
      <label className="block text-13px text-cendiatra my-5px">{titulo}</label>
      <NumericFormat
        thousandSeparator={'.'}
        decimalSeparator={','}
        decimalScale={2}
        fixedDecimalScale={true}
        prefix={prefix}
        value={valor}
        onValueChange={(values, sourceInfo) => {
          if (sourceInfo.source == 'event') {
            onValueChange(values)
          }
        }}
        className={estilosInput}
        placeholder={placeholder}
        disabled={deshabilitado}
        allowEmptyFormatting={formatoVacio}
        onFocus={onFocus}
        tabIndex={deshabilitarTab ? -1 : 0}
        isAllowed={isAllowed}
      />
    </div>
  )
}

export default InputMoneda
